import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import Input from '../../components/Input';
import Loading from '../../components/Loading';
import Modal from '../../components/Modal';
import Paginacao from '../../components/Paginacao';
// import SelectAsync from '../../components/SelectAsync';

import getValidationErrors from '../../utils/getValidationErrors';

import { AgendamentoLinha, AgendamentoLista } from './styles';

import getResponseErrors from '../../utils/getResponseErrors';
// import PacienteCadastro from '../../components/PacienteCadastro';
// import { IPacienteMaisCartaoDTO } from '../../components/Agendamento';
import { useClinica } from '../../hooks/clinica';
import SelectSync from '../../components/SelectSync';
import { TIPO_USUARIO } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';
import ProcedimentosCombo from './ProcedimentosCombo';

// interface ProfileFormDados {
//   pacienteID: string;
// }

export interface IAgendamentoComboDTO {
  AgeCodigo: number;
  AgeConfCodigo: number;
  AgePacCodigo: number;
  AgeInicio: string;
  dataFormatada: string;
  paciente: IPacienteComboDTO;
}

export interface IPacienteComboDTO {
  PacCodigo: number;
  PacNome: string;
}

interface IFormBusca {
  PacNome: string;
  CliCodigo: string;
}

interface IPaginacao {
  PacNome?: string;
  CliCodigo?: string;
  limite: number;
  pagina: number;
}

// interface IAgendamentoSelecionado {
//   AgeCodigo: number;
//   AgeConfCodigo: number;
// }

export interface IOption {
  value: string;
  label: string;
  isDisabled?: boolean;
}

const ListaCombo: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const { optionsClinica } = useClinica();
  const { user } = useAuth();
  const formRefBusca = useRef<FormHandles>(null);
  // const formRefPaciente = useRef<FormHandles>(null);

  const [agendamentos, setAgendamentos] = useState<
    IAgendamentoComboDTO[] | undefined
  >(undefined);
  // const [showModalPacienteCad, setShowModalPacienteCad] = useState(false);
  const [showModalCombos, setShowModalCombos] = useState(false);

  const [loading, setLoading] = useState(false);
  // const [showSelectPaciente, setShowSelectPaciente] = useState(false);

  // const [pacienteID, setPacienteID] = useState<number | undefined>();

  const [paginacao, setPaginacao] = useState<IPaginacao>();
  const [totalRegistros, setTotalRegistros] = useState<number | undefined>(
    undefined,
  );

  // function useQuery(): URLSearchParams {
  //   return new URLSearchParams(useLocation().search);
  // }

  // const query = useQuery();

  const initialData = {
    PacNome: '',
    CliCodigo: user.UsuClinica.toString(),
  };

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        PacNome: Yup.string(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });

      setAgendamentos(undefined);
      const { PacNome, CliCodigo } = dados;

      setPaginacao({
        ...(PacNome.toString().length > 1 ? { PacNome } : {}),
        ...(CliCodigo ? { CliCodigo } : {}),

        pagina: 1,
        limite: 20,
      });
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  useEffect(() => {
    formRefBusca.current?.submitForm();
  }, []);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        if (!paginacao) return;

        let parametros = `pagina=${paginacao.pagina}&limite=${paginacao.limite}`;
        const { PacNome, CliCodigo } = paginacao;
        if (PacNome) parametros += `&PacNome=${PacNome}`;
        if (CliCodigo) parametros += `&CliCodigo=${CliCodigo}`;

        const response = await api.get(
          `/agendamentos/buscaAgendamentosCombo?${parametros}`,
        );
        const responseApi: IAgendamentoComboDTO[] = response.data[0];

        setTotalRegistros(
          response.data[1] === 0 ? undefined : response.data[1],
        );

        const agendamentosFormatados = responseApi.map(age => {
          return {
            ...age,
            dataFormatada: format(
              parseISO(age.AgeInicio.toString()),
              'dd/MM/yyyy',
            ),
          };
        });
        setAgendamentos(agendamentosFormatados);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar Agendamentos de Combo',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }

    if (paginacao) loadDados();
  }, [addToast, paginacao]);

  const handleProximaPagina = useCallback((page: number) => {
    setPaginacao(state => {
      return state && { ...state, pagina: page };
    });
  }, []);

  const handleAgendarCombo = useCallback(
    (AgeCodigo: number, ConfCodigo: number) => {
      history.push(`AgendaCombo/edit/${AgeCodigo}/${ConfCodigo}`);
    },
    [history],
  );

  // const handleSelectClienteChange = useCallback(({ value }) => {
  //   if (value) {
  //     setPacienteID(Number(value));
  //   }
  // }, []);

  // const handleSubmitPaciente = useCallback((dados: ProfileFormDados) => {
  //   console.log('foi', dados);
  // }, []);

  // const handleCadastrouPaciente = useCallback((PacCodigo: number) => {
  //   setShowModalPacienteCad(false);
  //   setPacienteID(PacCodigo);
  // }, []);

  // useEffect(() => {
  //   async function loadDados(): Promise<void> {
  //     try {
  //       setLoading(true);
  //       const response = await api.get<IPacienteMaisCartaoDTO>(
  //         `/pacientes/pacientemaiscartao/${pacienteID}`,
  //       );

  //       history.push(`pacotetratamento/add/`, { paciente: response.data });
  //     } catch (error) {
  //       addToast({
  //         title: 'Não foi possível buscar o paciente',
  //         type: 'error',
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   if (pacienteID) loadDados();
  // }, [pacienteID, addToast, history]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  const handleOnChangeVazio = useCallback(() => { }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}

      {/* {showSelectPaciente && (
        <Modal
          show={showSelectPaciente}
          titulo="Adicionar Tratamento"
          handleFecharModal={
            () => {
              setShowSelectPaciente(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <>
            {loading && <Loading backgroundBlack={false} />}

            <Form
              ref={formRefPaciente}
              style={{ minHeight: '300px', padding: '.5rem' }}
              onSubmit={handleSubmitPaciente}
            >
              <SelectAsync
                name="pacienteID"
                label="Nome do Paciente"
                urlApi="pacientes/combo?termoBusca="
                placeholder="Digite para buscar"
                handleSelectChange={handleSelectClienteChange}
              />

              <Button
                className={loading ? 'd-none' : 'mt-3'}
                variant="outline-primary"
                size="sm"
                onClick={() => setShowModalPacienteCad(true)}
                disabled={loading}
              >
                Novo Paciente
              </Button>
            </Form>
          </>
        </Modal>
      )} */}

      {/* {showModalPacienteCad && (
        <Modal
          titulo="Cadastro de Paciente"
          show={showModalPacienteCad}
          handleFecharModal={
            () => {
              setShowModalPacienteCad(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <PacienteCadastro
            exibeMenu={false}
            pacCodigo={undefined}
            handleRetornaDados={
              dados => handleCadastrouPaciente(dados.PacCodigo)
              // eslint-disable-next-line react/jsx-curly-newline
            }
          />
        </Modal>
      )} */}
      {showModalCombos && (
        <Modal
          titulo="Combos Disponíveis"
          show={showModalCombos}
          large
          handleFecharModal={
            () => {
              setShowModalCombos(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <ProcedimentosCombo />
        </Modal>
      )}
      <div className="mb-2 p-2 bg-white border rounded">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h6 id="topoBusca">Pesquisa Combos Pagos</h6>

          <div>
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              onClick={() => setShowModalCombos(true)}
            >
              Ver Combos disponíveis
            </Button>
          </div>

          <div>
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              onClick={() => history.push('/agendas')}
            >
              Voltar para agendas
            </Button>
          </div>
        </div>
        {optionsClinica.length > 0 && user && (
          <Form
            ref={formRefBusca}
            initialData={initialData}
            onSubmit={handleSubmitBusca}
          >
            <Row noGutters>
              <Col sm={12} md={5} lg={3} className="pr-1">
                <Input
                  name="PacNome"
                  label="Nome"
                  maxLength={100}
                  minLength={3}
                />
              </Col>
              <Col sm={12} md={4} lg={2} className="pr-1">
                <SelectSync
                  name="CliCodigo"
                  label="Clinica"
                  options={optionsClinica}
                  handleSelectChange={handleOnChangeVazio}
                  isClearable
                  disabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                />
              </Col>
              <Col sm={12} md={3} lg={1} className="pr-1">
                <Button
                  type="submit"
                  size="sm"
                  style={{ margin: '21px 0 0 4px' }}
                  variant="primary"
                >
                  BUSCAR
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </div>

      <div className="bg-white border p-2 rounded">
        {agendamentos ? (
          <>
            {agendamentos.length > 0 ? (
              <>
                <Row
                  noGutters
                  className="bg-light py-2 border-top border-bottom"
                >
                  <Col md={1} lg={1}>
                    <b>Data</b>
                  </Col>
                  <Col md={4} lg={4}>
                    <b>Paciente</b>
                  </Col>

                  <Col md={2} lg={2} />
                </Row>
                {agendamentos.map(age => (
                  <AgendamentoLinha
                    className="row no-gutters"
                    key={`orcamento-${age.AgeCodigo}`}
                    data-id={age.AgeCodigo}
                  >
                    <div className="col-md-1 col-lg-1">
                      <AgendamentoLista>{age.dataFormatada}</AgendamentoLista>
                    </div>
                    <div className="col-md-4 col-lg-4">
                      <AgendamentoLista>
                        {age.paciente.PacNome}
                      </AgendamentoLista>
                    </div>

                    <div className={`col-md-2 col-lg-2 `}>
                      <AgendamentoLista>
                        <Button
                          type="button"
                          variant="primary"
                          size="sm"
                          title={`orcamento-${age.AgeCodigo}`}
                          onClick={
                            () =>
                              handleAgendarCombo(
                                age.AgeCodigo,
                                age.AgeConfCodigo,
                              )
                            // eslint-disable-next-line react/jsx-curly-newline
                          }
                        >
                          Agendar Procedimentos
                        </Button>
                      </AgendamentoLista>
                    </div>
                  </AgendamentoLinha>
                ))}
              </>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: '250px' }}
              >
                <h5>Sem resultados para a busca.</h5>
              </div>
            )}
          </>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '250px' }}
          >
            <h5>Pesquise pelo nome do paciente e clinica.</h5>
          </div>
        )}

        <Paginacao
          limitePagina={paginacao?.limite || 20}
          paginasVizinhas={2}
          totalRegistros={totalRegistros}
          paginaInicio={paginacao?.pagina}
          handleProximaPagina={handleProximaPagina}
        />
      </div>
    </Container>
  );
};

export default ListaCombo;
